<template>
  <v-app id="wrapper" :class="wrapperClass">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.2.0/css/all.css">

    <div v-bind:style="[menuActivado ? styleActivado : styleDesactivado]">
      <v-app-bar v-if="showMenu" app class="d-flex d-md-none topbar">
        <MenuToggleBtn v-if="showMenu"></MenuToggleBtn>
        <v-toolbar-title style="margin-left:50px">{{ title }}</v-toolbar-title>
      </v-app-bar>

      <Menu v-if="showMenu"></Menu>
    </div>

    <ContentOverlay></ContentOverlay>


    <v-content class="contenido">
      <router-view  @updateTitle="updateTitle"></router-view>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable no-console */

  import MenuToggleBtn from '@/components/MenuToggleBtn.vue'
  import Menu from '@/components/Menu.vue'
  import ContentOverlay from '@/components/ContentOverlay.vue'
  import { App } from './firebase/app';
  import 'firebase/messaging';
  import { Auth } from './firebase/auth';

  var request = require('request');
  var MobileDetect = require('mobile-detect');
  var md = new MobileDetect('Mozilla/5.0 (Linux; U; Android 4.0.3; en-in; SonyEricssonMT11i' +
    ' Build/4.1.A.0.562) AppleWebKit/534.30 (KHTML, like Gecko)' +
    ' Version/4.0 Mobile Safari/534.30');
  

export default {
  name: 'App',

  components: {
    MenuToggleBtn,
    Menu,
    ContentOverlay,
  },

  async created() {
    console.log("Created App");

    window.bus.$on('menu/toggle', () => {
    window.setTimeout(() => {
        this.isOpenMobileMenu = !this.isOpenMobileMenu;
      }, 200);
    });

    window.bus.$on('menu/closeMobileMenu', () => {
      this.isOpenMobileMenu = false;
    });

    window.bus.$on('menu/desactivarMenu', () => {
      this.menuActivado = false;
    });

    window.bus.$on('menu/activarMenu', () => {
      this.menuActivado = true;
    });

    let user = await Auth.getCurrentUser();

    if(user != null && md.os() === 'AndroidOS'){
      
      App.messaging().requestPermission()
      .then(() => {
        console.log("Have permission");
        return App.messaging().getToken();
      })
      .then( token => {
        if(token) {
          this.sendTokenToServer(token);
        }
        else {
          console.log('No Instance ID token available.');
          this.setTokenSentToServer(false);
        }
      })
      .catch( err => {
        console.log('An error occurred while retrieving token. ', err);
        this.setTokenSentToServer(false);
      })

      App.messaging().onTokenRefresh(() => {
        App.messaging().getToken().then((refreshedToken) => {
          console.log('Token refreshed.');
          this.setTokenSentToServer(false);
          this.sendTokenToServer(refreshedToken);
        }).catch((err) => {
          console.log('Unable to retrieve refreshed token ', err);
        });
      });

      App.messaging().onMessage( payload => {
        console.log("onMessage: ", payload);
      })
    }
  },

  data() {
    return {
      isOpenMobileMenu: false,
      menuActivado: true,
      styleActivado: {
        display: 'block'
      },
      styleDesactivado: {
        display: 'none'
      },
      titulo: "Ayuntamiento Pobladura de Pelayo García",
      title: ''
    };
  },

  methods : {
    sendTokenToServer(currentToken) {
      if (!this.isTokenSentToServer()) {
        console.log("Sending token to server...");

        request.post('https://us-central1-buzon-ayuntamiento.cloudfunctions.net/subscribeClientToken', {
          json: {
            token : currentToken
          }
        },(error, res, body) => {
          if (error) {
            console.error(error)
            return
          }
          console.log(`Status: ${res.statusCode}\nBody: ${body}`)
        })

        this.setTokenSentToServer(true);
      }
      else {
        console.log('Token already sent to server so won\'t send it again unless it changes');
      }
    },

    isTokenSentToServer() {
      return window.localStorage.getItem('sentToServer') === '1';
    },

    setTokenSentToServer(sent) {
      window.localStorage.setItem('sentToServer', sent ? '1' : '0');
    },

    updateTitle(title) {
      this.title = title;
    },
  },

  computed: {
    showMenu() {
      return this.$route.name !== 'login';
    },
    wrapperClass() {
      return {
        'toggled': this.isOpenMobileMenu === true,
      };
    },
  }
};
</script>

<style lang="scss">
  .mostrarMenu {
    display: none;
  }

  @media only screen and (orientation: landscape) and (max-width: 768px) {
    .logo {
      display: none !important;
    }
  }

  @media screen and (max-width: 960px){
    .contenido {
      padding-top: 2em!important;
    }
  }

  @media screen and (min-width: 960px){
    .contenido {
      padding-top: 0em!important;
    }
  }

  :root {
    --color-dark: #003B41;
    --color-medium-dark: #01535B;
    --color-medium: #026670;
    --color-medium-light: #0A808B;
    --color-light: #9FEDD7;
    --color-secondary-dark: #6A4800;
    --color-secondary-medium-dark: #956500;
    --color-secondary-medium: #B87D01;
    --color-secondary-medium-light: #E49F0E;
    --color-secondary-light: #F2BA42;
    --color-secondary-aux-dark: #FCE181;
    --color-secondary-aux-light: #FEF9C7;
    --color-grey: #EDEAE5;
    --color-white: #fff;
    --color-success: #2D8F1A;
    --color-danger-dark: #6A0500;
    --color-danger: #B80A01;
    --color-danger-medium: #E4190E;
    --color-danger-light: #F24B42;
    --color-info: #0671AB;
    --color-warn: #E49F0E;

    --color-menu-background: var(--color-medium);
    --color-menu-link-active: var(--color-medium-dark);
    --color-menu-hover: var(--color-dark);

    --color-logout-text: var(--color-secondary-light);
    --color-logout-hover: var(--color-secondary-light);
    --color-logout-background-hover: var(--color-dark);

    --color-toolbar: var(--color-medium);
    --color-toolbar-letra: var(--color-white);
    --color-toolbar-button: var(--color-secondary-light);
    --color-toolbar-button-letra: var(--color-dark);

    --color-calendar: var(--color-toolbar);

    --color-smile: var(--color-success);
    --color-frown: var(--color-danger);
  }

  @import 'styles/layout.scss';
  @import 'styles/menu-toggle-btn.scss';
  @import 'styles/menu.scss';
  @import 'styles/content-overlay.scss';
  @import 'styles/media-queries.scss';

  .toolbars {
    background-color: var(--color-toolbar)!important;
    color: var(--color-toolbar-letra)!important;
  }

  .toolbar-button {
    background-color: var(--color-toolbar-button)!important;
    color: var(--color-toolbar-button-letra)!important;
  }

  #v-data-table {
    color: var(--color-secondary-light)!important;
  }

  .iconoTabla {
    width: 300px!important;
  }

  .colorPos {
    color: var(--color-smile)!important;
  }

  .colorNeg {
    color: var(--color-frown)!important;
  }

  .colorInfo {
    color: var(--color-info)!important;
  }

  .colorWarn {
    color: var(--color-warn)!important;
  }

  .v-list{
    height: 80vh;
    overflow-y:auto
  }

  #menuToggle {
    color: var(--color-medium);
  }

  .sugerencias {
    margin-top:2em;
  }

  .adminConfig {
    margin-top:1em;
  }

  .workcloud-img {
    display:block; 
    width:75%;
    height:75%;
    max-height:500px;
    max-width:500px;
    padding: 1.5em;
  }
</style>